"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Poll_instances, _Poll_buildCastedModules;
Object.defineProperty(exports, "__esModule", { value: true });
const Base_1 = __importDefault(require("./Base"));
const Module_1 = __importDefault(require("./Module"));
const constants_1 = require("./constants");
const QuestionsMatrix_1 = __importDefault(require("./QuestionsMatrix"));
const ThanksModule_1 = require("./ThanksModule");
const { merge, get, omit } = require('lodash');
const defaults = {
    deviceType: {
        3: {
            encuesta: {
                metadata: {
                    strings: {
                        titleComments: 'let-comment',
                        titleFields: 'let-extra-information',
                    },
                },
            },
        },
        6: {
            encuesta: {
                metadata: {
                    strings: {
                        titleComments: 'let-comment',
                    },
                    settings: {
                        userDataFields: false,
                    },
                },
            },
        },
    },
    settings: {
        autoStep: false,
        commentsFields: false,
        userDataFields: false,
        userVisitFields: false,
        pageSize: 4,
        pageBreaks: [],
    },
    strings: {
        titleFields: 'let-extra-information',
        titleComments: 'any-additional-comments',
        motivosTitle: 'main-reason-opinion',
    },
};
class Poll extends Base_1.default {
    constructor(data = {}) {
        super({});
        _Poll_instances.add(this);
        this.modules = undefined;
        this.sortedQuestions = [];
        this.deviceType = 'unknown';
        this.name = '';
        this.has_store = false;
        this.metadata = {};
        this.selfMerge(constants_1.pollDefaults.base);
        this.selfMerge(omit(data, ['modules', 'questions', 'preguntas']));
        this.has_store = get(data, 'campaign.has_store', this.has_store);
        const rawModules = (data.modules || data.questions || data.preguntas || []);
        const newModules = [];
        let currentIndex = 0;
        rawModules.forEach((question) => {
            if (question.type === 'store' && this.has_store)
                return;
            if (get(question, 'type', 'question') === 'thanks') {
                newModules.push(new ThanksModule_1.ThanksModule(Object.assign(Object.assign({}, question), { poll: this })));
                currentIndex++;
                return;
            }
            ;
            newModules.push(new Module_1.default(Object.assign(Object.assign({}, question), { poll: this, index: currentIndex })));
            currentIndex++;
        });
        this.modules = newModules;
        this.sortedQuestions = __classPrivateFieldGet(this, _Poll_instances, "m", _Poll_buildCastedModules).call(this);
    }
    get settings() {
        return merge({}, defaults.settings, get(defaults, `deviceType[${this.deviceType}].settings`), this.metadata.settings, Poll.metadataOverride.settings);
    }
    get strings() {
        return merge({}, defaults.strings, get(defaults, `deviceType[${this.deviceType}].strings`), this.metadata.strings, Poll.metadataOverride.strings);
    }
    // /*
    // metadata encuesta
    // pageSize: 3
    // pageBreaks: [
    //   3,
    //   7
    // ];
    // 0: matrix: false
    // 1: matrix: false
    // 2: matrix: false
    // 3: matrix: false
    // 4: matrix: true
    // 5: matrix: true
    // 6: matrix: false
    // 7: matrix: true
    // 8: matrix: true
    // 9: matrix: false
    // Step 1: 0, 1, 2 (matrix: false) by PageSize
    // Step 2: 3 (matrix: false) by PageBreak
    // Step 3: 4, 5 (matrix: true), 6 (matrix: false), 7 (matrix: true) by PageBreak
    // Step 4: 8 (matrix: true), 9 (matrix: false) by EndOfArray
    // */
    getErrors(answers) {
        return this.sortedQuestions.reduce((reduced, item) => {
            return [...reduced, ...item.getErrors({ answers })];
        }, []);
    }
    getNextTo(item) {
        const index = this.sortedQuestions.findIndex((findIndex) => findIndex === item);
        // console.log("GET NEXT TO:");
        // console.log(item);
        // console.log("index: ",index," index+1",this.sortedQuestions[index + 1]);
        if (index === -1) {
            return undefined;
        }
        return this.sortedQuestions[index + 1];
    }
}
exports.default = Poll;
_Poll_instances = new WeakSet(), _Poll_buildCastedModules = function _Poll_buildCastedModules() {
    var _a;
    const sortedQuestions = [];
    let myCurrentMatrix;
    (_a = this.modules) === null || _a === void 0 ? void 0 : _a.forEach((pregunta, index) => {
        if (!(pregunta instanceof Module_1.default)) {
            sortedQuestions.push(pregunta);
            return;
        }
        const isMatrix = pregunta.getLayout() === 'matrix';
        const group = pregunta.getGroup();
        // const stepIsFull = (() => {
        //   return false;
        //   if (myCurrentStep.length >= pageSize) return true;
        //   if (pageBreaks.includes(index)) return true;
        //   return false;
        // })();
        // if (stepIsFull) {
        //   myCurrentStep = [];
        //   myCurrentMatrix = undefined;
        //   mySteps.push(myCurrentStep)
        // }
        if (isMatrix) {
            if (myCurrentMatrix !== undefined &&
                myCurrentMatrix.getGroup() === group) {
                myCurrentMatrix.push(pregunta);
            }
            else {
                myCurrentMatrix = new QuestionsMatrix_1.default([]);
                myCurrentMatrix.poll = this;
                myCurrentMatrix.push(pregunta);
                sortedQuestions.push(myCurrentMatrix);
            }
        }
        else {
            myCurrentMatrix = undefined;
            sortedQuestions.push(pregunta);
        }
    });
    return sortedQuestions;
};
Poll.metadataOverride = {};
